var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"distribution-map"}},[_c('l-map',{ref:"dist_map",staticStyle:{"height":"100%"},attrs:{"id":"l-map","maxBounds":_vm.maxBounds,"maxZoom":15,"zoom":1}},[_c('l-tile-layer',{attrs:{"clickable":true,"url":_vm.url}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }